import makeService from './api';

export default makeService('design_file_types');
